/**
 * Breadcrumbs functionality
 * Handles back button navigation and appends referrer collection at the end when coming from a collection (e.g. Sale).
 */

class Breadcrumbs {
  constructor() {
    this.backButtons = document.querySelectorAll('[data-breadcrumb-back]');
    this.breadcrumbNavs = document.querySelectorAll('.breadcrumbs');
    this.init();
  }

  init() {
    if (!this.backButtons || this.backButtons.length === 0) {
      return;
    }

    // Check if there's a referrer (came from another page)
    // If no referrer or referrer is from external site, hide back button
    const hasReferrer = document.referrer && document.referrer !== '';
    const isInternalReferrer = hasReferrer && document.referrer.startsWith(window.location.origin);
    const hasHistory = window.history.length > 1;

    if (!hasReferrer || !isInternalReferrer || !hasHistory) {
      this.hideBackButtons();
      return;
    }

    // Add click event listener to all back buttons
    this.backButtons.forEach((button) => {
      button.addEventListener('click', this.handleBackClick.bind(this));
    });
  }

  hideBackButtons() {
    if (!this.backButtons || this.backButtons.length === 0) {
      return;
    }

    this.backButtons.forEach((button) => {
      const backListItem = button.closest('.breadcrumbs__list-item--back');

      if (backListItem && backListItem instanceof HTMLElement) {
        backListItem.style.setProperty('display', 'none', 'important');
      } else {
        console.error('[Breadcrumbs] Error: Could not find parent list item for back button');
      }
    });
  }

  /** @param {Event} event */
  handleBackClick(event) {
    event.preventDefault();

    // Navigate back in browser history
    if (window.history.length > 1) {
      window.history.back();
    } else {
      // Fallback: redirect to home page if no history
      window.location.href = '/';
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new Breadcrumbs();
  });
} else {
  new Breadcrumbs();
}
